const url = ({value, isMandatory = true} : {value: string, isMandatory: Boolean}) => {
  if (isMandatory && !value) return 'URL is required';
  const URL_REGEX = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/i;
  return URL_REGEX.test(value) || 'Enter a valid URL';
};

const Validates = {
  url,
};

export default Validates;

export const VALIDATION_REGEX = {
   PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9"'\s\\])\S{8,}$/,
   EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
}